import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';

import footerArrow from '@/public/images/lp/komodo-wallet/footer-arrow.svg';
import ghIconsComplete from '@/public/images/lp/komodo-wallet/gh-icons-complete.png';
import ghIconsDesktop from '@/public/images/lp/komodo-wallet/gh-icons-desktop.png';

const StartBuilding = () => {
  return (
    <AnimateWhileInView delay={0.2}>
      <section className='relative mx-auto py-10 lg:py-20 z-[12]'>
        <div className='mx-auto sm:w-[400px] md:items-center md:w-full relative bg-black flex flex-col md:flex-row rounded-[14px]'>
          <div className='absolute w-full h-full overflow-hidden z-[5] rounded-[14px]'>
            <div className='absolute building-ellipse-1'></div>
          </div>
          <div className='flex flex-col py-4 md:py-5 z-[11] order-last md:order-first'>
            <h2 className='px-4 text-3xl font-bold text-white md:px-8 font-heading'>
              Start Building Now
            </h2>
            <div className='flex flex-col pr-6 md:mx-auto xl:flex-row'>
              <div className='flex flex-col xl:pr-12'>
                <h3 className='px-4 pt-8 text-base font-bold md:px-8 text-br-footer-gray xl:text-base '>
                  Developers:
                </h3>
                <Link
                  href='https://github.com/KomodoPlatform/komodo-defi-framework'
                  target='_blank'
                  className=''
                >
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8'>
                      Protocol repo &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
                <Link
                  href='https://github.com/KomodoPlatform/komodo-wallet-desktop'
                  target='_blank'
                  className=''
                >
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8'>
                      Desktop GUI repo &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
                <Link href='https://github.com/KomodoPlatform/komodo' target='_blank' className=''>
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8 '>
                      Komodo &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
              </div>
              <div className='flex flex-col'>
                <h2 className='px-4 pt-8 text-base font-bold md:px-8 text-br-footer-gray xl:text-base '>
                  Knowledge Base:
                </h2>

                <Link
                  href='https://komodoplatform.com/en/docs/komodo-defi-framework/tutorials/listing-a-new-coin/'
                  target='_blank'
                  className=''
                >
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8 '>
                      Listing a coin/token &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
                <Link
                  href='https://atomicdex.io/en/blog/atomic-swaps/'
                  target='_blank'
                  className=''
                >
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8 '>
                      About atomic swaps &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
                <Link
                  href='https://komodoplatform.com/en/docs/komodo-defi-framework/'
                  target='_blank'
                  className=''
                >
                  <div className='flex'>
                    <span className='pt-2 pl-4 text-base font-medium text-white md:pl-8 '>
                      Read the developer docs &#8599;
                    </span>
                    {/* <ExportedImage
                      src={footerArrow}
                      className="h-auto pt-2 ml-2"
                      alt="side arrow"
                    /> */}
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <ExportedImage
            src={ghIconsComplete}
            className='h-auto xl:hidden relative w-[400px] lg:w-[500px] z-[11] scale-[100.5%] md:mr-10 order-first md:order-last'
            alt='gh-icons'
          />
          <ExportedImage
            src={ghIconsDesktop}
            className='order-last h-[230px] hidden xl:block  w-auto z-[11] absolute right-0 top-0'
            alt='gh-icons'
          />
        </div>
      </section>
    </AnimateWhileInView>
  );
};

export default StartBuilding;
